import { useEffect } from 'react';
import { useMockServerStore } from '../store/mockServerStore';
import { useCollectionsStore } from '../store/collectionsStore';
import { useTabsStore } from '../store/tabsStore';
import { reloadMockServer, buildMockDataset } from '../services/mockServerService';

/**
 * Keeps the local mock server in sync with saved + in-tab (unsaved) mock
 * examples. Debounced reload whenever collections/schemas/tabs change while the
 * mock server is running — and only while `active` (signed in, past the
 * desktop gate: useSignedInServices).
 */
export function useMockServerSync({ active = true } = {}) {
  const mockServerRunning = useMockServerStore((s) => s.running);
  const collections = useCollectionsStore((s) => s.collections);
  const schemas = useCollectionsStore((s) => s.schemas);
  const requestTabs = useTabsStore((s) => s.requestTabs);
  const schemaTabs = useTabsStore((s) => s.schemaTabs);

  useEffect(() => {
    if (!active || !mockServerRunning) return undefined;
    const id = setTimeout(() => {
      reloadMockServer(
        buildMockDataset(
          { collections, schemas },
          useTabsStore.getState().requestTabs,
          useTabsStore.getState().schemaTabs
        )
      ).catch(() => {});
    }, 400);
    return () => clearTimeout(id);
  }, [active, mockServerRunning, collections, schemas, requestTabs, schemaTabs]);
}
